<template>

  <div id="app">
    <v-app id="inspire">
      <v-content>
        <v-container fluid class="loginPage">
          <v-layout fill-height justify-center>
            <v-card class="loginContainer my-auto">
              <v-layout row wrap fill-height>
                <!-- bloque lateral izquierdo -->
                <v-flex md5 class="loginLeftContainer">
                  <v-img :src="stylePath + '/img/loginBackground.jpg'" height="100%" class="imgBg">
                    <v-container fill-height fluid>
                      <v-layout row wrap fill-height justify-center align-center>
                        <v-flex shrink>
                          <v-flex text-xs-center xs12 my-4>
                            <v-img :src="stylePath + '/img/logoLogin.png'" class="logo mx-auto"></v-img>
                            <p class="loginWelcome hidden-sm-and-down mb-0 mt-4">
                              {{$t('accesoInformes') }}.
                            </p>
                            <span class="loginText hidden-sm-and-down">
                              <div v-if="!dIsViso">{{$t('gestionPresupuestos')}}</div>
                              <div v-else>{{$t('areaClientes')}}</div>
                            </span>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                </v-flex>
                <!-- formulario -->
                <v-flex md7 class="pa-4 my-auto loginRegisterContainer">
                  <v-form v-model="validaFormulario" ref="form" lazy-validation>
                    <p class="loginTitle py-2 mb-0"> {{$t('login')}}
                    </p>
                    <v-flex class="loginFormContainer">
                      <v-layout row wrap>
                        <v-flex xs12 py-2>
                          <v-text-field :rules="requiredRules" id="userName" required class="mt-2" color="datPrimary" prepend-icon="perm_identity" name="user" v-model="usuario" :label="$t('usuario')" @keydown.enter="iniciaSesion()" :readonly="dEsperandoLogin">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 py-2>
                          <v-text-field :rules="requiredRules" id="password" required class="mt-2" color="datPrimary" prepend-icon="lock_open" name="password" v-model="password" :label="$t('contrasenya')" :append-icon="mostrarPassword ? 'visibility' : 'visibility_off'" @click:append="() => (mostrarPassword = !mostrarPassword)" :type="mostrarPassword ? 'password' : 'text'" counter @keydown.enter="iniciaSesion()" :readonly="dEsperandoLogin">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 v-show="!this.existsUrlDomain" py-2>
                          <v-text-field :rules="requiredRules" id="dominio" required class="mt-2" color="datPrimary" prepend-icon="link" name="domain" v-model="dominio" :label="$t('dominio')" @keydown.enter="iniciaSesion()" :readonly="dEsperandoLogin">
                          </v-text-field>
                        </v-flex>
                        <v-flex class="text-xs-right py-2">
                          <v-btn dark flat id='initSession' :class="'data-bntStandard datPrimary'" @click="iniciaSesion()" :disabled=" dEsperandoLogin">
                            {{$t('iniciarSesion')}}
                            <v-progress-circular v-if="dEsperandoLogin" :rotate="-90" :size="20" :width="3" color="white" class="ma-0 ml-2" indeterminate>
                            </v-progress-circular>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card>
          </v-layout>
        </v-container>
      </v-content>
      <!-- alerta de avisos -->
      <!-- comprobacion borrado -->
      <v-dialog v-model="mostrarAvisos" persistent max-width="400px">
        <v-card class="data-aviso">
          <v-card-title class="subheading">
            <v-flex xs12>
              <v-icon large class="accent--text">error_outline</v-icon>
            </v-flex>
            <v-flex xs12 mb-3 class="text-xs-center">
              <span v-html="textAviso"></span>
            </v-flex>
          </v-card-title>
          <v-card-actions pt-4>
            <v-spacer></v-spacer>
            <v-btn class="datPrimaryBtn" @click="mostrarAvisos=false">{{this.$t('cerrar')}}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--Alerta para cambiar la empresa si es onPremise-->
      <ShpCambioEmpresaDialog @cerrar="fCerrarModal()" :pEmpresaInformes="dEmpresaInformes" :pEmpresaERP="dEmpresaERP" :pTextAvisoCambioEmpresa="dTextAvisoCambioEmpresa" v-model="dMostrarAvisoCambioEmpresa"></ShpCambioEmpresaDialog>
    </v-app>
  </div>

</template>
 

<script>

import VueRecaptcha from 'vue-recaptcha'

// Mixins
import mxLogin from '@/mixins/globals/mx-login'

// Components
import ShpCambioEmpresaDialog from '@/components/Dialogs/ShpCambioEmpresaDialog'

export default {
  name: 'ShpLogin',
  components: {
    VueRecaptcha,
    ShpCambioEmpresaDialog
  },
  mixins: [mxLogin],

  data () {
    return {
      captcha: false,
      captchaSiteKey: process.env.CAPTCHA_SITE_KEY,
      mostrarPassword: true,
      usuario: '',
      password: '',
      dominio: '',
      politicaPrivacidad: false,
      requiredRules: [
        v => !!v || this.$t('campoRequerido')
      ],
      validaFormulario: '',
      mostrarAvisos: false,
      textAviso: '',
      token: '',
      dScreenWidth: screen.width,
      dEsperandoLogin: false,
      dIsViso: false
    }
  },
  mounted () {
    if (this.urlDomain !== undefined && this.urlDomain !== null && this.urlDomain !== 'undefined') {
      this.dominio = this.urlDomain
    } else {
      this.dominio = 'SPAZIAERP2T1' //GDATADEC
    }
    if (!this.urlShowCaptcha) {
      this.captcha = true
    }
    if (localStorage.getItem('headerDomain') === 'JVISO' || localStorage.getItem('headerDomain') === 'JVISOERP2T1') {
      this.dIsViso = true
    }
  },
  created () {
    this.$store.commit('removeAutenticacion')
    this.captchaSiteKey = process.env.CAPTCHA_SITE_KEY
  },
  methods: {

    fCerrarModal () {
      this.dEsperandoLogin = false
      this.dMostrarAvisoCambioEmpresa = false
    }

  }
}

</script>



// WEBPACK FOOTER //
// src/components/ShpLogin.vue